// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","voltar":"NotFound_voltar__bZl0U"};